export default __webpack_public_path__ + "static/media/sojarelatoriodiario.8bc51969.png";